import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Form, InputGroup } from "react-bootstrap";
import { Toast } from "primereact/toast";
import UserLoginForm from "./user/userLogin";
import MemberLoginForm from "./member";
import SmsVerification from "./verification/sms";
import ResetPassword from "../resetPassword";
import AuthContext from "../context";
import logoLight from "../../../assets/img/logo/main-logo-light.svg";
import logoDark from "../../../assets/img/logo/main-logo-dark.svg";
import { ThemeContext } from "../../../context/theme-context";
import "../login/Login.scss";
import TwoFactorVerification from "../OTPverification/OTPverification";
import SmsVerificationResetPassword from "../resetPassword/components/SmsVerification/SmsVerification";
import ThemeSwitcher from "../../../components/theme-switcher/ThemeSwitcher";

export default function Login() {
  const navigate = useNavigate();

  const toast = useRef(null);

  const user = useSelector((state) => state.auth?.user);

  const contextVal = useContext(AuthContext);

  const currentTheme = useContext(ThemeContext).theme;
  const logo = currentTheme === "dark" ? logoDark : logoLight;

  // Get the login type from localStorage or use the default "KullaniciGirisi"
  const [loginTypeSelectItem, setLoginTypeSelectItem] = useState(
    localStorage.getItem('hisselab_login_type') || "KullaniciGirisi"
  );

  const rememberMe = useSelector((state) => state.auth?.rememberMe);

  const loginView = contextVal?.authState.loginView;
  const smsVerificationView = contextVal?.authState.smsVerificationView;
  const passwordResetView = contextVal?.authState.passwordResetView;
  const twoFactorVerification = contextVal?.authState.twoFactorVerification;

  useEffect(() => {
    //Bir kullanıcı varsa direk watchlist sayfasına yönlendir.
    rememberMe && user && navigate("/StockAnalysis/summary/TUPRS");

    // Check URL parameters first as they should override localStorage preference
    const currentPath = window.location.search;
    const queryString = currentPath.split('?')[1];

    if (queryString && queryString.includes("UyeGirisi")) {
      setLoginTypeSelectItem("UyeGirisi");
      // Also update localStorage with the URL parameter value
      localStorage.setItem('hisselab_login_type', "UyeGirisi");
    } else {
      // Use the value from localStorage (already loaded in state initialization)
      const savedLoginType = localStorage.getItem('hisselab_login_type');
      if (savedLoginType) {
        setLoginTypeSelectItem(savedLoginType);
      }
    }

  }, []);

  const registerRedirect = () => {
    navigate("/auth/register");
  };

  const loginTypeChange = (item) => {
    // Save the selected login type to localStorage
    localStorage.setItem('hisselab_login_type', item);
    setLoginTypeSelectItem(item);
  };

  const goLogin = () => {
    navigate("/auth/login");

  }

  return (
    <div id="loginPage">
      <Toast ref={toast} position="bottom-right" />

      <Container className="header-container">
        <Row className="header-container-row">
          <Col>
            <Image src={logo} fluid onClick={goLogin} />
          </Col>
          <Col>
            <div className='theme-btn'><ThemeSwitcher /></div>
          </Col>
        </Row>
      </Container>

      <div className="login-content">
      <Container className="mainContainer">
        <Row className="justify-content-center">
          <Col md="6">
            {loginView && (
              <Col md="12" className="loginFormContainer">
                <Form>
                  <Row>
                    <Col lg="6" className={`element ${loginTypeSelectItem === "KullaniciGirisi" ? "activeLoginType" : ""} ${"loginType"}`} onClick={() => loginTypeChange("KullaniciGirisi")}>
                      <Form.Check
                        onChange={(e) => loginTypeChange(e.target.value)}
                        inline
                        className="loginTypeRadio"
                        value="KullaniciGirisi"
                        label="Kullanıcı Girişi"
                        name="group2"
                        type="radio"
                        id={`login-type-user`}
                        checked={loginTypeSelectItem === "KullaniciGirisi" ? true : false}
                      />
                    </Col>
                    <Col lg="6" className={`element ${loginTypeSelectItem === "UyeGirisi" ? "activeLoginType" : ""} ${"loginType"}`} onClick={(e) => loginTypeChange("UyeGirisi")}>

                      <Form.Check

                        inline
                        className="loginTypeRadio"
                        value="UyeGirisi"
                        label="Üye Girişi"
                        name="group2"
                        type="radio"
                        id={`login-type-memeber`}
                        onChange={(e) => loginTypeChange(e.target.value)}
                        checked={loginTypeSelectItem === "UyeGirisi" ? true : false}
                      />
                    </Col>
                  </Row>
                </Form>
                <Row className="">
                  <Col lg="12" md="12">
                    {loginTypeSelectItem == "KullaniciGirisi" && <UserLoginForm />}
                    {loginTypeSelectItem == "UyeGirisi" && <MemberLoginForm />}
                  </Col>
                </Row>
              </Col>
            )}
            {smsVerificationView && <SmsVerification />}
            {twoFactorVerification && <TwoFactorVerification />}
            {passwordResetView && <ResetPassword />}

          </Col>

        </Row>
      </Container>
      </div>
    </div>
  );
}

